import { BorderBox, Button, CommunityGuidelinesLink } from "./index.js";
import { TagIcon } from "../assets/icons/index.js";

export default function TopicsSection({
  onTopicClick,
  topics,
  selectedTopic,
  className = "",
  showGuidelines = false,
}) {
  return (
    <div className={`flex flex-col gap-4 w-full md:w-1/4 ${className}`}>
      <h1 className="text-4xl uppercase text-lz-candle-dim dark:text-lz-concrete">
        Topics
      </h1>
      <BorderBox className="h-fit md:mt-4">
        <div className="flex flex-col gap-4">
          {topics.map((topic) => (
            <Button
              icon={<TagIcon />}
              key={topic.index}
              onClick={() => onTopicClick?.(topic.index)}
              selected={selectedTopic === topic.index}
            >
              {topic.label}
            </Button>
          ))}
        </div>
      </BorderBox>
      {showGuidelines && <CommunityGuidelinesLink className="mt-6" />}
    </div>
  );
}
